import type { RawUserAnswer, Survey, SurveyState, SurveyStatus } from './types';

import DialogService from '@/services/dialogs/DialogService';

const mutations = {
  setPreviewSurveyId(state: SurveyState, surveyId: string) {
    state.previewSurveyId = surveyId;
  },
  clearPreviewSurveyId(state: SurveyState) {
    state.previewSurveyId = null;
  },
  setPublishedSurveyId(state: SurveyState, surveyId: string | null) {
    state.publishedSurveyId = surveyId;
  },
  updateIsMinimized(state: SurveyState, isMinimized: boolean) {
    state.isSurveyMinimized = isMinimized;
  },
  updateSurveyPopUpId(state: SurveyState, { surveyId, popUpId }: { surveyId: string; popUpId: number | null }) {
    if (state.surveys[surveyId]) {
      state.surveys[surveyId].surveyPopUpId = popUpId;
    }
  },
  updateSurveyStatus(state: SurveyState, { surveyId, status }: { surveyId: string; status: SurveyStatus }) {
    if (state.surveys[surveyId]) {
      state.surveys[surveyId].surveyStatus = status;
    }
  },
  lastQuestionAnsweredIndex(state: SurveyState, { surveyId, index }: { surveyId: string; index: number }) {
    state.surveys[surveyId].lastQuestionAnsweredIndex = Math.max(
      state.surveys[surveyId].lastQuestionAnsweredIndex,
      index
    );
  },
  clearSurvey(state: SurveyState) {
    Object.values(state.surveys).forEach((survey: Survey) => {
      if (survey?.surveyPopUpId !== null) {
        DialogService.close(survey?.surveyPopUpId);
      }
    });
    state.surveys = {};
    state.previewSurveyId = null;
    state.publishedSurveyId = null;
    state.isSurveyMinimized = false;
  },
  setSurvey(state: SurveyState, survey: Survey) {
    Object.assign(state.surveys, { [survey.id]: survey });
  },
  deleteSurvey(state: SurveyState, surveyId: string) {
    delete state.surveys[surveyId];
  },
  setSurveyAnswer(
    state: SurveyState,
    { surveyId, questionId, answer }: { surveyId: string; questionId: string; answer: RawUserAnswer }
  ) {
    Object.assign(state.surveys[surveyId].answerMap, { [questionId]: answer });
  },
  removeSurveyAnswer(state: SurveyState, { surveyId, questionId }: { surveyId: string; questionId: string }) {
    delete state.surveys[surveyId].answerMap[questionId];
  },
  updateLoadingState(state: SurveyState, loadingState: boolean) {
    state.showLoading = loadingState;
  }
};

export type SurveyMutations = typeof mutations;
export default mutations;
